<template>
  <div class="list-box common-shadow clearfix">
    <vxe-table
      class="table-style"
      stripe
      highlight-hover-row
      show-footer
      show-overflow
      max-height="540"
      border="none"
      :loading="loading"
      :data="collectionListData"
      :auto-resize="true"
      align="center"
      :footer-method="footerMethod"
      @cell-click="cellClick"
      ref="xTable"
    >
      <vxe-table-column type="seq" title="序号" width="90"></vxe-table-column>
      <vxe-table-column
        field="paymentsNum"
        title="收付款编号"
        width="130"
        class-name="link-text"
      ></vxe-table-column>
      <vxe-table-column field="flowNum" title="流程编号" width="130">
        <template slot-scope="{ row }">
          <span
            @click="openProcedureDetail(row.flowId, 2)"
            style="color: #2d8cf0; cursor: pointer"
            >{{ row.flowNum }}</span
          >
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="ownName"
        title="所属方"
        :filters="filterOwnName"
      ></vxe-table-column>
      <vxe-table-column
        field="clientName"
        title="客户名称"
        :filters="filterclientName"
      ></vxe-table-column>
      <vxe-table-column
        field="addTime"
        title="日期"
        width="110"
      ></vxe-table-column>
      <vxe-table-column field="note" title="摘要"></vxe-table-column>
      <vxe-table-column field="debiteAmount" title="借方金额（已付）">
        <template slot-scope="{ row }">
          <span>{{ row.debiteAmount | formatMoney }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="creditAmount" title="贷方金额（应付）">
        <template slot-scope="{ row }">
          <span>{{ row.creditAmount | formatMoney }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="balanceAmount" title="余额">
        <template slot-scope="{ row }">
          <span>{{ row.balanceAmount | formatMoney }}</span>
        </template>
      </vxe-table-column>
    </vxe-table>

    <vxe-modal
      v-model="isShowPaymentDetail"
      width="1300"
      height="660"
      resize
      remember
      title="收付款详情"
    >
      <payment-detail
        :cate="'Payment'"
        :isShow="isShowPaymentDetail"
        :chainId="id"
        ref="paymentDetail"
        @close="isShowPaymentDetail = false"
        @init="init"
      ></payment-detail>
    </vxe-modal>
    <vxe-modal
      v-model="receivingDeailModal"
      width="1300"
      height="700"
      position="center"
      title="托运人货物交接结算确认"
    >
      <p slot="title" class="box-tit-211130">
        <span>托运人货物交接结算确认</span>
      </p>
      <buyer-receiving-detail ref="receivingDetail"></buyer-receiving-detail>
    </vxe-modal>
    <vxe-modal
      v-model="sellerReceivingDeailModal"
      width="1300"
      height="700"
      position="center"
      title="承运人货物交接结算确认"
    >
      <p slot="title" class="box-tit-211130">
        <span>承运人货物交接结算确认</span>
      </p>
      <seller-receiving-detail
        ref="sellerReceivingDetail"
      ></seller-receiving-detail>
    </vxe-modal>
    <vxe-modal
      v-model="secondReceivingDeailModal"
      width="1300"
      height="700"
      position="center"
      title="实际承运人货物交接结算确认"
    >
      <p slot="title" class="box-tit-211130">
        <span>实际承运人货物交接结算确认</span>
      </p>
      <second-receiving-detail
        ref="secondReceivingDetail"
      ></second-receiving-detail>
    </vxe-modal>
    <vxe-modal
      v-model="isShowCarryOverDetail"
      title="结转详情"
      width="1300"
      height="460"
      resize
      remember
    >
      <carry-over-detail
        :isShow="isShowCarryOverDetail"
        ref="carryOverDetail"
        @close="isShowCarryOverDetail = false"
      ></carry-over-detail>
    </vxe-modal>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import { timeFormatDate } from "@/filters/time";
import { numberToCurrency } from "@/filters/type";
import PaymentDetail from "@/views/payment/PaymentDetail.vue";
import SellerReceivingDetail from "../../../views/receiving/SellerReceivingDetail";
import { goReceiveGoods, paymentFooter, getFilterObj } from "@/utils/util";
import openProcedureDetail from "@/mixin/viewOrderDetail";
import SecondReceivingDetail from "@/views/receiving/SecondReceivingDetail";
import BuyerReceivingDetail from "@/views/receiving/BuyerReceivingDetail";
import CarryOverDetail from "@/views/payment/CarryOverDetail.vue";
import getAuthOrization from "@/mixin/getAuthOrization";

export default {
  components: {
    PaymentDetail,
    SellerReceivingDetail,
    SecondReceivingDetail,
    BuyerReceivingDetail,
    CarryOverDetail,
  },
  props: {
    id: Number,
    isSecondSeller: Number,
    pageTab: String,
  },
  mixins: [getAuthOrization,openProcedureDetail],
  data() {
    return {
      loading: false,
      collectionListData: [],
      isShowPaymentDetail: false,
      isShowSellerReceivingDetail: false,
      receivingDeailModal: false,
      secondReceivingDeailModal: false,
      sellerReceivingDeailModal: false,
      isShowCarryOverDetail: false,
      filterOwnName: [],
      filterclientName: [],
    };
  },
  watch: {
    // id(nv, ov) {
    //   if (nv !== ov && nv !== undefined) {
    //     this.getCollectionListData();
    //   }
    // },
    isSecondSeller: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.cate = val === 0 ? "Payment" : "SellerPayment";
      },
    },
    pageTab() {
      this.pageTab === "tab5" ? this.getCollectionListData() : "";
    },
  },
  // activated() {
  //   // this.getCollectionListData();
  //   this.$bus.$on("allOrderDetailRenovate", (data) => {
  //     data === true ? this.getCollectionListData() : "";
  //   });
  // },
  methods: {
    init() {
      this.getCollectionListData();
    },
    // footerMethod() {},
    async getCollectionListData() {
      this.filterOwnName = [];
      this.filterclientName = [];
      this.collectionListData = [];
      this.loading = true;
      let res = await $api.payments.request("queryPaymentsSellerList", {
        chainId: this.id,
        orderBy: 3,
        isDesc: 0,
      });
      if (res.status === 1) {
        let collectionListData = res.data.rows;
        const xTable = this.$refs.xTable;
        const ownNameColumn = xTable.getColumnByField("ownName");
        const clientNameColumn = xTable.getColumnByField("clientName");
        collectionListData.map((i) => {
          getFilterObj(this.filterOwnName, i.ownName);
          getFilterObj(this.filterclientName, i.clientName);
          i.addTime = timeFormatDate(i.addTime);
          if (i.paymentsState === 1) {
            i.paymentsNum = i.receiveNum;
          }
        });
        xTable.setFilter(ownNameColumn, this.filterOwnName);
        xTable.setFilter(clientNameColumn, this.filterclientName);
        xTable.updateData();
        this.collectionListData = collectionListData;
        this.loading = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    footerMethod({ columns, data }) {
      return paymentFooter({ columns, data });
    },
    viewCarryOverDetail(id) {
      this.isShowCarryOverDetail = true;
      this.$refs.carryOverDetail.initDetail(id);
    },
    cellClick(e) {
      let field = e.column.property;
      if (field === "paymentsNum") {
        if (e.row.sourceType === 6) {
          // 打开结转流程
          this.viewCarryOverDetail(e.row.id);
        } else {
          if (e.row.paymentsState === 2) {
            if (!this.isHavePermission('PaymentsSeller')){
              this.$Message["info"]({
                background: true,
                content: "对不起，您没有该权限！"
              });
              return ;
            }
            this.isShowPaymentDetail = true;
            this.$refs.paymentDetail.init(e.row.id);
          } else {
            if (e.row.receiveNum.indexOf("CG") != -1) {
              if (!this.isHavePermission('buyer:ReceDetail')){
                this.$Message["info"]({
                  background: true,
                  content: "对不起，您没有该权限！"
                });
                return ;
              }
              this.receivingDeailModal = true;
              this.$refs.receivingDetail.getReceivingDetail({
                id: e.row.receiveGoodsId,
              });
            } else if (e.row.receiveNum.indexOf("CS") != -1) {
              if (!this.isHavePermission('seller:ReceDetail')){
                this.$Message["info"]({
                  background: true,
                  content: "对不起，您没有该权限！"
                });
                return ;
              }
              this.sellerReceivingDeailModal = true;
              // this.getReceivingDetail(row);
              this.$refs.sellerReceivingDetail.getReceivingDetail({
                id: e.row.receiveGoodsId,
              });
            } else if (e.row.receiveNum.indexOf("CA") != -1) {
              if (!this.isHavePermission('sellerLv2:ReceDetail')){
                this.$Message["info"]({
                  background: true,
                  content: "对不起，您没有该权限！"
                });
                return ;
              }
              this.secondReceivingDeailModal = true;
              // this.getReceivingDetail(row);
              this.$refs.secondReceivingDetail.getReceivingDetail({
                id: e.row.receiveGoodsId,
              });
            }
          }
        }
      }
    },
  },
};
</script>

<style>
</style>